import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export type CarouselProps = {
  children: React.ReactElement[]
};

export const CarouselUI: React.FC<CarouselProps> = ({ children }) => {
  if (children.length === 1) return children;
  return (
    <Carousel
      dynamicHeight
      showThumbs={false}
      showStatus={false}
    >
      {children}
    </Carousel>
  );
};
